"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAltForSelfLang = void 0;
const Language_1 = __importDefault(require("@opsbase/lib-i18n/Language"));
const react_1 = require("react");
const useSelfLanguage_1 = __importDefault(require("../useSelf/useSelfLanguage"));
function useAltForSelfLang(v, vAlt) {
    const { language } = (0, useSelfLanguage_1.default)();
    const isAlt = language !== Language_1.default.ENGLISH;
    const currentV = isAlt ? (vAlt === null || vAlt === void 0 ? void 0 : vAlt[language]) || v : v;
    const [value, setValue] = (0, react_1.useState)(currentV);
    (0, react_1.useEffect)(() => {
        if (value !== currentV)
            setValue(currentV);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentV]);
    return [value, setValue];
}
exports.useAltForSelfLang = useAltForSelfLang;
exports.default = useAltForSelfLang;
